/**
 * Validates the company creation/edit form.
 * @param {object} values - The form values.
 * @returns {object} An object containing error messages.
 */
export default function validateCompanyForm(values) {
  let errors = {};

  // Name validation
  if (!values.name || values.name.trim() === '') {
    errors.name = 'Company name is required.';
  } else if (values.name.length > 100) {
    errors.name = 'Company name must be less than 100 characters.';
  }
  
  // Description validation (optional)
  if (values.description && values.description.length > 500) {
    errors.description = 'Description must be less than 500 characters.';
  }

  // Currency validation
  if (!values.currency || values.currency.trim() === '') {
    errors.currency = 'Currency is required.';
  }

  // Address validation
  if (!values.address || !values.address.line1) {
    errors.address = 'Street address is required.';
  }
  if (!values.address || !values.address.suburb) {
    errors.address = 'Suburb or City is required.';
  }
  if (!values.address || !values.address.postcode) {
      errors.address = 'Postcode is required.';
  }
  if (!values.address || !values.address.country) {
      errors.address = 'Country is required.';
  }
  if (!values.address || !values.address.state) {
      errors.address = 'State is required.';
  }


  return errors;
}
